/**
 * iter-370 — Minimal, safe Markdown-to-HTML converter for BOQ descriptions
 * and T&C content.
 *
 * We DO NOT depend on a full Markdown library — this is deliberately
 * scoped to the tokens Bella's AI actually emits: **bold**, *italic*,
 * line breaks. Everything else is HTML-escaped so nothing user-provided
 * can inject markup or attributes.
 */

function escapeHtml(str) {
  return String(str)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');
}

export function renderLightMarkdown(input) {
  if (!input) return '';
  const escaped = escapeHtml(input);
  return escaped
    // **bold** — captured non-greedily to avoid gobbling across lines
    .replace(/\*\*([^*\n]+?)\*\*/g, '<strong class="font-semibold text-stone-900">$1</strong>')
    // *italic* — same non-greedy scope
    .replace(/(^|[^*])\*([^*\n]+?)\*(?!\*)/g, '$1<em>$2</em>')
    // newlines → <br/>
    .replace(/\n/g, '<br/>');
}

/**
 * Returns { __html } props object ready to spread into
 * `dangerouslySetInnerHTML={...}` — signals to the caller that the
 * conversion has already been sanitised.
 */
export function markdownHtmlProps(input) {
  return { __html: renderLightMarkdown(input) };
}
